import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";

const MiniDialog = ({
  open,
  onClose,
  title = "Add Notes",
  label = "Complaint",
  placeholder = "Enter Complaint",
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSave) {
      const formData = new FormData(e.currentTarget);
      onSave(formData.get("Notes")); // Notes field ka data pass kar diya
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          padding: "8px",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #eee",
          pb: 1,
        }}
      >
        <ArgonTypography variant="h5" fontWeight="bold">
          {title}
        </ArgonTypography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Body */}
      <DialogContent sx={{ mt: 2 }}>
        <form onSubmit={handleSubmit}>
          <ArgonBox mb={2}>
            <ArgonTypography
              variant="body2"
              fontWeight="medium"
              mb={1}
              color="text"
            >
              {label}
            </ArgonTypography>
            <ArgonInput
              name="Notes"
              placeholder={placeholder}
              multiline
              rows={4}
              fullWidth
            />
          </ArgonBox>

          {/* Footer */}
          <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
            <ArgonButton
              variant="outlined"
              color="secondary"
              onClick={onClose}
              sx={{ borderRadius: "8px", textTransform: "none" }}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              type="submit"
              variant="contained"
              color="primary"
              sx={{ borderRadius: "8px", textTransform: "none" }}
            >
              Save
            </ArgonButton>
          </ArgonBox>
        </form>
      </DialogContent>
    </Dialog>
  );
};

MiniDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  title: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

export default MiniDialog;
